import { getAuth } from "firebase/auth";
import { useEffect, useState } from "react";
import GetAllBooks from "../../../../Controllers/Common/GetAllBooks";
import GetUser from "../../../../Controllers/Users/GetUser";

export default function SchoolLibraryListingViewModel() {
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [AuthUser, setAuthUser] = useState();
  const [BooksArray, setBooksArray] = useState([]);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      const BooksData = await GetAllBooks(SchoolID);
      setBooksArray(BooksData);
      setIsLoading(false);
    }
    fetchData();
  }, [SchoolID]);

  return {
    BooksArray,
    AuthUser,
    IsLoading,
  };
}
